import React from "react";
import TeamDashboardPage from "./TeamDashboardPage";

export default function FollowUpPage() {
  return <TeamDashboardPage />;
}
